/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MoveToIcon = ({ width = 24, height = 24, hidden = false, title = 'Move To' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M21.879 20.344a1 1 0 0 1-1.414 0l-4.809-4.809a1 1 0 0 1 0-1.414L23.777 6H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V12.223Z"
    />
    <path
      d="M23.707 2a.5.5 0 0 0-.353.854l3.482 3.482-8.136 8.139a.5.5 0 0 0 0 .707l2.118 2.118a.5.5 0 0 0 .707 0l8.139-8.139 3.482 3.483a.5.5 0 0 0 .854-.351V2Z"
    />
  </svg>`;
};
